import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CommunicationsListPage } from '@/pages/member-portal/communications/CommunicationsListPage';

// Loose so the child editor/detail route keeps its own search keys.
const communicationsSearchSchema = z.looseObject({
	page: z.coerce.number().optional().catch(undefined),
	limit: z.coerce.number().optional().catch(undefined),
	search: z.string().optional().catch(undefined),
	status: z.enum(['DRAFT', 'SENT', 'ARCHIVED']).optional().catch(undefined),
	sort: z.enum(['newest', 'oldest', 'due']).optional().catch(undefined),
});

function MemberPortalManageCommunicationsRoute() {
	return <CommunicationsListPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/communications')({
	component: MemberPortalManageCommunicationsRoute,
	validateSearch: communicationsSearchSchema,
});
